export const ARGENTINA_CENTER = { lat: -38.4161, lng: -63.6167 };

export const ARGENTINA_BOUNDS = {
  north: -21.78,
  south: -55.06,
  west: -73.58,
  east: -53.59,
};

export const ROUTE_STROKE_COLOR = "#4a90e8";

export const MARKER_COLORS = {
  origen: { bg: "#2e7d32", border: "#1b5e20", icon: "#1b5e20" },
  destino: { bg: "#c62828", border: "#b71c1c", icon: "#b71c1c" },
  agencia: { bg: "#90a4ae", border: "#607d8b", icon: "#ffffff" },
  agenciaSelected: { bg: "#2e7d32", border: "#1b5e20", icon: "#ffffff" },
};

export const PIN_STYLES = {
  origen: {
    background: MARKER_COLORS.origen.bg,
    borderColor: MARKER_COLORS.origen.border,
    glyphColor: "#FFFFFF",
    glyphText: "▶",
    scale: 1.15,
  },
  destino: {
    background: MARKER_COLORS.destino.bg,
    borderColor: MARKER_COLORS.destino.border,
    glyphColor: "#FFFFFF",
    glyphText: "⚑",
    scale: 1.15,
  },
  agencia: {
    background: MARKER_COLORS.agencia.bg,
    borderColor: MARKER_COLORS.agencia.border,
    glyphColor: "#FFFFFF",
    glyphText: "🏢",
    scale: 1,
  },
  agenciaSelected: {
    background: MARKER_COLORS.agenciaSelected.bg,
    borderColor: MARKER_COLORS.agenciaSelected.border,
    glyphColor: "#FFFFFF",
    glyphText: "🏢",
    scale: 1.2,
  },
};

export const locationsKey = (locations) =>
  locations.map((location) => `${location.lat},${location.lng}`).join("|");
